<!-----------------------------------------------------------------------------
  Copyright (c) 2016 - 2021.                                                  -
  Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)           -
  All Rights Reserved.                                                        -
                                                                              -
  The software and data contained herein are confidential and proprietary     -
  information of Yega Yazilim ("Confidential Information").                   -
                                                                              -
  Users of this software may not disclose such Confidential Information and   -
  shall use it only in accordance with the terms of the license agreement     -
  they entered into with Yega Yazilim.                                        -
                                                                              -
  Author:  Ahmet Dogramaci                                                    -
  Date:    2021-02-22                                                         -
  ----------------------------------------------------------------------------->

<template>
  <div>
    <h2 class="text-primary mb-4">{{ templateVersion.attribute_store['short-name'] }}</h2>
    <b-form>
      <b-form-group v-for="category_node in category_nodes" :key="category_node.id"
                    :label="category_node.name"
                    label-class="text-danger font-weight-bold">
        <div :class="{'card border-info':hasPromotionText(category_node)}"
             :style="{true:'border-width: medium'}[hasPromotionText(category_node)]">
          <div :class="{'card-body':hasPromotionText(category_node)}">
            <b-form-select
                v-model="selected_node_id_by_category_node_id[category_node.id]"
                :options="options_by_category_node_id[category_node.id]"
                @change="handleOptionChange(category_node,$event)"
                value-field="id"
                text-field="name"
                required>
            </b-form-select>
            <b-alert variant="info" :show="hasPromotionText(category_node)">{{ promotionText(category_node) }}</b-alert>
          </div>
        </div>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import ConfigurationTemplateVersion from "../../business-objects/configuration-template-version";
import YesNo from "../../enums/yes-no";
import QuoteProduct from "../../business-objects/quote-product";
import useCurrencyFormatter from "../../compositions/use-currency-formatter";

export default {
  name: "configuration-dialog",
  props: {
    templateVersion: {
      type: ConfigurationTemplateVersion,
      required: true
    },
    quoteProduct:{
      type: QuoteProduct,
      required: true
    },
    isPublic:{
      type: Boolean,
      default: false
    }
  },
  setup(){
    const { formatCurrency } = useCurrencyFormatter();
    return {
      formatCurrency
    };
  },
  computed: {
    category_nodes() {
      return this.templateVersion.nodes
          .filter((node) => {
            return node.attribute_store['item-type'] === 'category';
          })
          .filter((node) => {
            return node.attribute_store['input'] === 'select';
          })
          .sort((node1, node2) => {
            if (node1.attribute_store['order'] < node2.attribute_store['order']) {
              return -1;
            }
            if (node1.attribute_store['order'] > node2.attribute_store['order']) {
              return 1;
            }
            return 0;
          });
    },
    nodes_by_id() {
      return this.templateVersion.nodes.reduce((object, node) => {
        object[node.id] = node;
        return object;
      }, {});
    },
    hidden_attribute_name(){
      return this.isPublic ? 'hide-on-standard-dialog' : 'hide-on-bid-dialog'
    },
    options_by_category_node_id() {
      return this.category_nodes.reduce((object, category_node) => {
        object[category_node.id] =
            this.templateVersion.nodes.filter((node) => {
              return node.isVisible &&
                  node.attribute_store['item-type'] === 'content' &&
                  node.attribute_store['category'] === category_node.attribute_store['category'] &&
                  node.attribute_store[this.hidden_attribute_name] !== YesNo.YES;
            }).sort((node1, node2) => {
              if (node1.attribute_store['order'] < node2.attribute_store['order']) {
                return -1;
              }
              if (node1.attribute_store['order'] > node2.attribute_store['order']) {
                return 1;
              }
              return 0;
            })
                .map((node) => {
                  let price = '0';
                  if (node.calculated_price_transformations) {
                    price = node.calculated_price_transformations['esup'];
                  }
                  let formatted_price = this.formatCurrency(price)
                  return {id: node.id, name: `${node.name} [${formatted_price}]`, disabled:node.isDisabled};
                });
        return object;
      }, {});
    },
    selected_node_id_by_category_node_id() {
      return this.category_nodes.reduce((object, category_node) => {
        let selected_node = this.templateVersion.selected_nodes.find((node) => {
          return node.attribute_store['item-type'] === 'content' && node.attribute_store['category'] === category_node.attribute_store['category'];
        });
        object[category_node.id] = selected_node.id;
        return object;
      }, {});
    }
  },
  methods: {
    handleOptionChange(category_node, selected_node_id) {
      let to_be_selected_node = this.nodes_by_id[selected_node_id];
      to_be_selected_node.select();
    },
    hasPromotionText(category_node) {
      let selected_node_id = this.selected_node_id_by_category_node_id[category_node.id];
      let selected_node = this.nodes_by_id[selected_node_id];
      return selected_node && !!selected_node.attribute_store['cic-promotion-text']
    },
    promotionText(category_node) {
      let selected_node_id = this.selected_node_id_by_category_node_id[category_node.id];
      let selected_node = this.nodes_by_id[selected_node_id];
      return selected_node.attribute_store['cic-promotion-text'];
    }
  }
}
</script>

<style scoped>

</style>
